import {
    Component,
  } from '@angular/core';
  import { 
    SidebarService 
  } from '../../_services';
  
  @Component({
    templateUrl: 'data-integration-toolkit-home-it.component.html',
    styleUrls:["../../../assets/css/common.css"]
  })
  export class DataIntegrationToolkitHomeItComponent 
  {
    constructor(private sidebarService:SidebarService) {}

    Top()
    {
    window.scroll(0,0);
    }

  }
  